import React from 'react'

function Currency() {
    return (
        <div className='currency'>
            <div className="other_overlay"></div>
            <div className="currency_container">
                <div className="currency_content">
                    <h2>
                        Please choose your Country Currency .
                    </h2>
                    <div className="selections">
                    <select name="event" id="event">
                        <option value="wedding"> </option>
                        <option value="conference">United Arab Emirates dirham</option>
                        <option value="meetings">Afghan afghani</option>
                        <option value="sport">Albanian lek</option>
                        <option value="sport">Armenian dram</option> 
                        <option value="sport">Netherlands Antillean guilder</option>
                        <option value="sport">Angolan kwanza</option>
                        <option value="sport">Argentine peso</option>
                        <option value="sport">Australian dollar</option>
                        <option value="sport">Aruban florin</option>
                        <option value="sport">Azerbaijani manat</option>
                        <option value="sport">Barbados dollar</option>
                    </select>
                </div>
                </div>
            </div>
            
        </div>
    )
}

export default Currency
